import React, { Suspense } from 'react';
import { useTab } from '../../contexts/TabContext';
import { TAB_REGISTRY, DYNAMIC_ROUTES } from '../../constants/tabRegistry';
import { PageLoader } from '../PageLoader';
import NotFoundContent from './NotFoundContent';
import App from '../../App';
import { matchPath } from 'react-router-dom';

/**
 * TabContainer - 탭 컨테이너 컴포넌트
 *
 * display:none/block 방식으로 탭 페이지 상태를 보존하며 활성 탭을 렌더링한다.
 */
export function TabContainer() {
  const { tabs, activeTabId, showHome } = useTab();

  return (
    <>
      {/* Home page — always mounted, shown when no tab is active */}
      <div style={{ display: showHome ? 'block' : 'none', height: '100%', overflow: 'auto' }}>
        <App />
      </div>

      {/* Tab pages — rendered directly, hidden via display:none */}
      {tabs.map((tab) => {
        const entry = resolveTabEntry(tab.path);
        if (!entry) {
          return (
            <div
              key={tab.id}
              style={{
                display: tab.id === activeTabId && !showHome ? 'block' : 'none',
                height: '100%',
                overflow: 'auto',
                position: 'relative',
              }}
            >
              <NotFoundContent path={tab.path} />
            </div>
          );
        }

        const Component = entry.component;
        const props = { ...(entry.props || {}), ...(entry.params || {}) };

        return (
          <div
            key={tab.id}
            style={{
              display: tab.id === activeTabId && !showHome ? 'block' : 'none',
              height: '100%',
              overflow: 'auto',
              position: 'relative',
            }}
          >
            <Suspense fallback={<PageLoader />}>
              <Component {...props} />
            </Suspense>
          </div>
        );
      })}
    </>
  );
}

/**
 * Resolve a tab path to its registry entry (static or dynamic).
 */
function resolveTabEntry(path) {
  if (TAB_REGISTRY[path]) return TAB_REGISTRY[path];
  for (const route of DYNAMIC_ROUTES) {
    const match = matchPath(route.pattern, path);
    if (match) return { ...route, params: match.params };
  }
  return null;
}
